package api.traak

sealed class CloudFunction(
    val endpoint: String,
) {
  object ExportView : CloudFunction("exportView")
}
